import React, { Component } from 'react';
import { BankUserContext } from '../bankUserContext';
import FinSpinner from '../commonfields/FinSpinner';
import { WithRouterProps, withRouter } from '../components/shared/WithRouter';
import Service from '../services';
import { RoutesEnum } from '../utils/RoutesUtil';

interface IDocuSignPageState {
  loader: boolean,
  clientUuid: string | null,
  displayIframe: boolean,
  iframeUrl: string | null,
}

class DocuSignPage extends Component<WithRouterProps<unknown>, IDocuSignPageState> {
    service: Service;
    static contextType = BankUserContext; 
    constructor(props: WithRouterProps<unknown>) {
      super(props);
      this.state = {
        loader: true,
        clientUuid: null,
        displayIframe: false,
        iframeUrl: null,
      };
      this.service = new Service();
    }
  
    componentDidMount() {
      const pathValues = this.props?.location?.pathname?.split('/')
      // console.log('chnage')
      if (pathValues?.includes(RoutesEnum.DOCU_SIGN_REDIRECT)) {
        const queryParams = new URLSearchParams(window.location.search);
        const envelopeId = queryParams.get('envelopeId');
        const signingOption = queryParams.get('signingOption');
        const event = queryParams.get("event");
        const clientUuid = window.parent.location.pathname?.split('/')?.[2];
        // console.log(queryParams, clientUuid)
        if (event === "signing_complete" || event === "decline") {
          this.setState({ loader: true })
          this.service.docuSignWebhook(
            event,
            envelopeId, 
            clientUuid,
            signingOption
          ).then(() => {
            // console.log('successss')
            this.setState({ loader: false })
            window.parent.location.reload();             
          })
        } else {
          this.setState({ loader: false })
          window.parent.location.reload();
        } 
      }
    }

    render() {
      const {  loader } = this.state;
 
      return <>
        { loader ? <FinSpinner /> : <></>}
      </>;
    }
}

export default withRouter<WithRouterProps<unknown>>(DocuSignPage);
